import { FONTS } from '../../../../constants/fonts';
import {
    ptFactor,
    SIZE_OPTIONS, sizeScale
} from '../../../../constants/sizes';

const lineHeight = 62 / 52;
const factor1 = 0.86 * (33 / 52); // 0.86 may be moved to the return obj
const factor2 = 0.86 * (31.25 / 29);

const lpTitleFontSize = factor1 * 52 * sizeScale;
const ptTitleFontSize = factor1 * 45 * sizeScale * ptFactor;
const mbTitleFontSize = factor1 * 66 * sizeScale * ptFactor;

const lpTextFontSize = factor2 * 29 * sizeScale;
const ptTextFontSize = factor2 * 24 * sizeScale * ptFactor;
const mbTextFontSize = mbTitleFontSize * 1.2;

const textWidthDp = 26;
const textWidthMb = 21;
const textWidthPt = 23;
const textWidthMbLp = 23;

export const getTitleMetrics = (orientation) => {
    const base = {
        fontFamily: FONTS.ACCENT,
        isUpperCase: true,
        lineHeight,
        align: 'left'
    };

    if (orientation === SIZE_OPTIONS.LANDSCAPE) {
        return {
            ...base,
            fontSize: lpTitleFontSize,
            width: textWidthDp * lpTitleFontSize
        };
    }

    if (orientation === SIZE_OPTIONS.PORTRAIT) {
        return {
            ...base,
            fontSize: ptTitleFontSize,
            width: textWidthPt * ptTitleFontSize
        };
    }

    if (orientation === SIZE_OPTIONS.MOBILE_LANDSCAPE) {
        return {
            ...base,
            fontSize: lpTitleFontSize * 1.05,
            width: textWidthMbLp * lpTitleFontSize * 1.05
        };
    }

    return {
        ...base,
        fontSize: mbTitleFontSize,
        width: textWidthMb * mbTitleFontSize
    };
};

export const getTextMetrics = (orientation) => {
    const base = {
        fontFamily: FONTS.REGULAR,
        lineHeight,
        align: 'left'
    };

    if (orientation === SIZE_OPTIONS.LANDSCAPE) {
        return {
            ...base,
            fontSize: lpTextFontSize
        };
    }

    if (orientation === SIZE_OPTIONS.PORTRAIT) {
        return {
            ...base,
            fontSize: ptTextFontSize
        };
    }

    if (orientation === SIZE_OPTIONS.MOBILE_LANDSCAPE) {
        return {
            ...base,
            fontSize: lpTextFontSize * 1.05
        };
    }

    return {
        ...base,
        fontSize: mbTextFontSize
    };
};

export const getCommentMetrics = (orientation) => {
    const base = {
        fontFamily: FONTS.REGULAR,
        lineHeight,
        align: 'left'
    };

    if (orientation === SIZE_OPTIONS.LANDSCAPE) {
        return {
            ...base,
            fontSize: lpTextFontSize,
            width: textWidthDp * lpTitleFontSize * 0.9
        };
    }

    if (orientation === SIZE_OPTIONS.PORTRAIT) {
        return {
            ...base,
            fontSize: ptTextFontSize,
            width: textWidthPt * ptTitleFontSize * 0.9
        };
    }

    if (orientation === SIZE_OPTIONS.MOBILE_LANDSCAPE) {
        return {
            ...base,
            fontSize: lpTextFontSize * 1.05,
            width: textWidthMbLp * lpTextFontSize * 1.05
        };
    }

    return {
        ...base,
        fontSize: mbTextFontSize,
        width: textWidthMb * mbTitleFontSize
    };
};

export const getTextLayoutStyle = (orientation) => {
    const base = {
        deltaWidth: 2.6,
        deltaHeight: 1.7,
        commentDeltaWidth: 2.6 * 2,
        commentDeltaHeight: 1.7 * 2,
        commentMinHeight: 12,
        roundRadius: 1,
        optionRelativeWidth: 0.93,
        optionDeltaWidth: 2.4,
        optionDeltaHeight: 1.2,
        optionMargin: 0.7 * (30 / 31.25)
    };

    if (orientation === SIZE_OPTIONS.MOBILE_PORTRAIT) {
        return {
            ...base,
            commentDeltaWidth: 2.6,
            commentDeltaHeight: 1.7 * 2.2,
            commentMinHeight: 10
        };
    }

    if (orientation === SIZE_OPTIONS.MOBILE_LANDSCAPE) {
        return {
            ...base,
            commentDeltaWidth: 2.6,
            commentDeltaHeight: 1.7,
            commentMinHeight: 10
        };
    }

    return base;
};
